import { render, staticRenderFns } from "./ReferralReport.vue?vue&type=template&id=b3cbfd5e&scoped=true&"
import script from "./ReferralReport.vue?vue&type=script&lang=js&"
export * from "./ReferralReport.vue?vue&type=script&lang=js&"
import style0 from "./ReferralReport.vue?vue&type=style&index=0&id=b3cbfd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cbfd5e",
  null
  
)

export default component.exports